import { useState } from 'react'
import { AssistantDrawer } from './AssistantDrawer'
import { Avatar } from './Avatar'

export function AssistantButton() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-30 bg-gradient-to-br from-blue-500 to-purple-600 text-white rounded-full shadow-lg hover:shadow-xl transition-shadow hover:scale-105 transform dark:from-blue-600 dark:to-purple-700"
        aria-label="Open assistant"
      >
        <div className="scale-90 md:scale-100">
          <Avatar size="md" />
        </div>
        <span className="absolute -top-1 -right-1 w-3 h-3 md:w-4 md:h-4 bg-green-500 rounded-full border-2 border-white dark:border-gray-900"></span>
      </button>

      <AssistantDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
